// The router lazy-loads each portal page from here, and OmpLayout warms the same chunks once
// the shell is idle, so the first visit to a page doesn't wait on its download.

export const OMP_PAGE_LOADERS = {
  home: () => import('./pages/OmpHome'),
  subscriptions: () => import('./pages/OmpSubscriptions'),
  subscriptionDetails: () => import('./pages/OmpSubscriptionDetails'),
  orders: () => import('./pages/OmpOrders'),
  orderDetails: () => import('./pages/OmpOrderDetails'),
  account: () => import('./pages/OmpAccount'),
  addresses: () => import('./pages/OmpAddresses'),
  paymentMethods: () => import('./pages/OmpPaymentMethods'),
}

export function preloadOmpPages(): void {
  Object.values(OMP_PAGE_LOADERS).forEach(load => {
    load().catch(() => {})
  })
}
